import type { CSSProperties, FC } from "react";
import { cn } from "@/lib/cn";

type SpinnerProps = {
  size?: number;
  className?: string;
};

export const Spinner: FC<SpinnerProps> = ({ size = 40, className }) => (
  <div className={cn("spinner", className)} style={{ width: size } as CSSProperties} />
);
